import React, { useState, useEffect } from "react";
import { Row, Col, FormGroup, Label, Input } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { setAnswers } from "../../../../redux/slices/SearchBarSlice";

const InquiryAnswers = () => {
  const { sampleAd, answers } = useSelector((state) => state.searchBar);
  const [questions, setQuestions] = useState([]);
  const [errors, setErrors] = useState({}); // Track validation errors
  const dispatch = useDispatch();
  const islogin = useSelector((state) => state.user.isLogin);
  useEffect(() => {
    if (sampleAd?.Questions) {
      try {
        const parsedQuestions = JSON.parse(sampleAd.Questions);
        const validQuestions = parsedQuestions.filter(
          (q) =>
            q.id &&
            q.label &&
            q.type &&
            ((q.type !== "options" && q.type !== "check") ||
              (Array.isArray(q.options) && q.options.length > 0))
        );
        setQuestions(validQuestions);
      } catch (error) {
        console.error("Failed to parse sampleAd questions:", error);
        setQuestions([]);
      }
    } else {
      setQuestions([]);
    }
  }, [sampleAd]);
  console.log(sampleAd, "sampleAd");
  // Validate a single question's answer
  const validateAnswer = (question, answer) => {
    if (!question.mandatory) return true; // Non-mandatory questions are always valid
    if (answer === undefined || answer === null) return false;
    if (question.type === "text" && (!answer || answer.trim() === "")) {
      return false;
    }
    if (question.type === "options" && (!answer || answer === "")) {
      return false;
    }
    if (
      question.type === "check" &&
      (!Array.isArray(answer) || answer.length === 0)
    ) {
      return false;
    }
    return true;
  };

  // Handle answer changes
  const handleAnswerChange = (label, type, value, option = null) => {
    const updatedAnswers = { ...answers };
    if (type === "check") {
      // For check questions, manage an array of selected options
      const currentSelections = Array.isArray(updatedAnswers[label])
        ? updatedAnswers[label]
        : [];
      if (value) {
        // Add option if checked
        if (!currentSelections.includes(option)) {
          updatedAnswers[label] = [...currentSelections, option];
        }
      } else {
        // Remove option if unchecked
        updatedAnswers[label] = currentSelections.filter(
          (opt) => opt !== option
        );
      }
      // Remove key if array is empty
      if (updatedAnswers[label].length === 0) {
        delete updatedAnswers[label];
      }
    } else {
      // For text and options questions
      const isEmpty =
        (type === "text" && value === "") ||
        (type === "options" && value === "");
      if (isEmpty) {
        delete updatedAnswers[label];
      } else {
        updatedAnswers[label] = value;
      }
    }
    dispatch(setAnswers(updatedAnswers));

    // Update errors
    const question = questions.find((q) => q.label === label);
    if (question && question.mandatory) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [label]: !validateAnswer(question, updatedAnswers[label])
          ? "This field is required"
          : "",
      }));
    }
  };
  return (
    <>
      {questions.length > 0 && (
        <div>
          {questions.map((question, index) => (
            <FormGroup key={index}>
              <Label>
                <strong>
                  {index + 1}. {question.label}
                  {question.mandatory && (
                    <span style={{ color: "red" }}> *</span>
                  )}
                </strong>
              </Label>
              {question.type === "text" && (
                <>
                  <Input
                    type="text"
                    value={answers[question.label] || ""}
                    onChange={(e) =>
                      handleAnswerChange(
                        question.label,
                        question.type,
                        e.target.value
                      )
                    }
                    placeholder="Enter your answer"
                    invalid={!!errors[question.label]}
                  />
                  {errors[question.label] && (
                    <div
                      style={{
                        color: "#d32f2f",
                        fontSize: "0.75rem",
                        marginTop: "4px",
                      }}
                    >
                      {errors[question.label]}
                    </div>
                  )}
                </>
              )}
              {question.type === "options" && (
                <>
                  <Input
                    type="select"
                    value={answers[question.label] || ""}
                    onChange={(e) =>
                      handleAnswerChange(
                        question.label,
                        question.type,
                        e.target.value
                      )
                    }
                    invalid={!!errors[question.label]}
                  >
                    <option value="">Select an option</option>
                    {question.options.map((option, index) => (
                      <option key={index} value={option}>
                        {option}
                      </option>
                    ))}
                  </Input>
                  {errors[question.label] && (
                    <div
                      style={{
                        color: "#d32f2f",
                        fontSize: "0.75rem",
                        marginTop: "4px",
                      }}
                    >
                      {errors[question.label]}
                    </div>
                  )}
                </>
              )}
              {question.type === "check" && (
                <>
                  {question.options &&
                    question.options.map((option, index) => (
                      <FormGroup
                        check
                        key={index}
                        className="d-flex align-items-center"
                      >
                        <Input
                          type="checkbox"
                          checked={
                            Array.isArray(answers[question.label]) &&
                            answers[question.label].includes(option)
                          }
                          onChange={(e) =>
                            handleAnswerChange(
                              question.label,
                              question.type,
                              e.target.checked,
                              option
                            )
                          }
                          invalid={!!errors[question.label]}
                        />
                        <Label className="ms-2">{option}</Label>
                      </FormGroup>
                    ))}
                  {errors[question.label] && (
                    <div
                      style={{
                        color: "#d32f2f",
                        fontSize: "0.75rem",
                        marginTop: "4px",
                      }}
                    >
                      {errors[question.label]}
                    </div>
                  )}
                </>
              )}
            </FormGroup>
          ))}
        </div>
      )}
    </>
  );
};

export default InquiryAnswers;
